import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import {
  dateSchema,
  parseToDateValue,
  preprocessTextAsyncAutocompleteField,
} from "@/features/FormCard/utils";
import { ClientTables } from "@/lib/clientTables";
import { Clients } from "@/lib/clients";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterM2DataUploadSchema = z.object({
  file_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  provider_config_name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});
const filterM2DataUpload = filterM2DataUploadSchema.keyof().enum;

export const ConfigSchema = z.object({
  id: z.number(),
  code: z.string(),
  file_pattern: z.string().optional(),
  client: z.string().optional(),
  mime_type: z.string().optional(),
  template_s3_key: z.string().optional(),
  usage_description: z.string().optional(),
});

export const UploadSchema = z.object({
  config_name: z.string().min(1, "La configuration est requise"),
  files: z
    .array(z.instanceof(File))
    .nonempty("Vous devez ajouter au moins un fichier"),
});

export type UploadSchemaType = z.infer<typeof UploadSchema>;
export type ConfigSchemaType = z.infer<typeof ConfigSchema>;

export type FilterM2DataUploadSchema = z.infer<typeof filterM2DataUploadSchema>;

export function M2DataUploadFilter() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: filterM2DataUpload.file_name_contains,
      label: t(
        `${ClientTables.M2_DATA_UPLOAD}.filter.${filterM2DataUpload.file_name_contains}`,
      ),
      type: "asyncAutocomplete",
      base_url: `${Clients.M2}/${ClientTables.M2_DATA_UPLOAD}`,
      column_name: "file_file_name",
    },
    {
      name: filterM2DataUpload.provider_config_name_contains,
      label: t(
        `${ClientTables.M2_DATA_UPLOAD}.filter.${filterM2DataUpload.provider_config_name_contains}`,
      ),
      type: "asyncAutocomplete",
      base_url: `${Clients.M2}/${ClientTables.M2_DATA_UPLOAD}`,
      column_name: "provider_config_name",
    },
    {
      name: "created_at",
      type: "dateRange",
      label: t(`${ClientTables.M2_DATA_UPLOAD}.filter.created_at`),
      from: { name: filterM2DataUpload.created_at_from },
      to: { name: filterM2DataUpload.created_at_to },
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      client={Clients.M2}
      schema={filterM2DataUploadSchema}
      tableName={ClientTables.M2_DATA_UPLOAD}
      fields={fields}
    />
  );
}
